export default __webpack_public_path__ + "static/media/17.048a533b.jpg";